import {
  Box,
  Button,
  Grid,
  IconButton,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import { ControlPoint, EditNote, EditSharp } from "@mui/icons-material";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { $crud } from "../../utils/CrudFactory";
import { usePagination } from "../../hooks";
import DynamicTable from "../../components/DynamicTable";
import { acceptedCategoryFilters } from "../../utils/filterConfig";
import AddCategoryModal from "../../components/modals/AddCategoryModal";
import editimg from "../../assets/images/svg/editblack.svg";

export function WebsiteBanner() {
  const theme = useTheme();
  const navigate = useNavigate();
  const [searchInput, setSearchInput] = useState("");
  const [expandedRows, setExpandedRows] = useState([]);
  const [rows, setRows] = useState([]); //STATE TO GET THE ORDER LIST
  const { page, limit, setLimit, setPage, total, setTotal } = usePagination(); // PAGINATION PROPS
  const [inputDisabled, setDisabled] = useState(true);
  const [bannerInput, setBannerInput] = useState("");

  async function handleUpdateBanner() {
    try {
      const res = await $crud.put(`admin/website-banner`, {
        bannerId: rows[0]._id,
        message: bannerInput,
      });
      setBannerInput(res.data.banner.message);
      setRows([res.data.banner]);
      setDisabled(true);
    } catch (e) {
      setBannerInput(rows[0].message);
    }
  }

  // STATE TO MANAGE FILTERS --------------------------------------
  const [filtrationData, setFiltrationData] = useState({
    search: "",
    from: "",
    to: "",
  });
  // STATE TO MANAGE FILTERS --------------------------------------
  async function retrieveData() {
    const isFilterApplied = Object.values(filtrationData).some(
      (value) => value !== "" && value !== false
    );

    const params = {
      search: filtrationData.search,
      from: filtrationData.from,
      to: filtrationData.to,
    };

    // Conditionally include limit and page if no filters are applied
    if (!isFilterApplied) {
      params.limit = limit;
      params.page = page;
    }

    const { data } = await $crud.retrieve("admin/website-banner");

    return data;
  }
  useEffect(() => {
    // RUNNING THE retrieveData() FUNCTION ---------------------------------

    retrieveData().then((res) => {
      setRows(res.result);
      setTotal(res.total);
      setBannerInput(res.result[0].message);
    });
    // RUNNING THE retrieveData() FUNCTION ---------------------------------
  }, [limit, page, filtrationData]);

  const handleSearchInputChange = (value) => {
    if (value.trim() === "") {
      setFiltrationData((prevData) => ({
        ...prevData,
        search: "",
      }));
      setSearchInput("");
    }
    setSearchInput(value);
    setFiltrationData((prevData) => ({
      ...prevData,
      search: value,
    }));
  };

  const handleCloseModal = () => {
    navigate("/others/accepted-categories");
  };

  const handleAddCategory = async (name) => {
    // Logic to update position with reason
    const { data, type } = await $crud.post(`admin/accepted-category`, {
      name,
    });
    if (type == "success") {
      // navigate("/services/tutorials");
    }
    handleCloseModal();
  };

  // COLUMNS IN THE ORDER TABLE-----------------------------
  const clientColumns = [
    {
      id: "banner",
      label: "Banner",
      align: "start",
      renderCell: (row) => {
        return (
          <TextField
            value={bannerInput}
            onChange={(e) => setBannerInput(e.target.value)}
            sx={{
              fontSize: "12px",
              backgroundColor: "white",
              width: "100%",
            }}
            disabled={inputDisabled}
            InputProps={{
              sx: {
                "& input": {
                  cursor: inputDisabled ? "not-allowed" : "text",
                },
              },
            }}
          />
        );
      },
    },
    // {
    //   id: "createdAt",
    //   label: "Created Date",
    //   align: "center",
    // },
    // {
    //   id: "assignedOrders",
    //   label: "Assigned Orders",
    //   align: "center",
    // },
    // //   {
    // //     id: "status",
    // //     label: "Status",
    // //     align: "center",
    // //   },
    // {
    //   id: "status",
    //   label: "Status",
    //   align: "center",
    //   renderCell: (row) => {
    //     const getStatusStyles = (status) => {
    //       switch (status) {
    //         case "Active":
    //           return {
    //             background: "rgb(37, 137, 0)",
    //           };
    //         case "Disabled":
    //           return {
    //             background: "rgb(193, 0, 0)",
    //           };
    //         default:
    //           return {
    //             background: "#FFF0ED",
    //           };
    //       }
    //     };
    //     const styles = getStatusStyles(row.status);
    //     return (
    //       <Button
    //         sx={{
    //           background: styles.background,
    //           cursor: "auto",
    //           borderRadius: "22px",
    //           color: "white",
    //           padding: "7px 27px",
    //           textTransform: "capitalize",
    //           border: "none",
    //           fontSize: "12px",
    //           width: "100px",
    //           outline: "none !important",
    //           "&:hover": {
    //             outline: styles.background,
    //             background: styles.background,
    //           },
    //           "&:focus": {
    //             outline: styles.background,
    //             background: styles.background,
    //           },
    //         }}
    //       >
    //         {row.status}
    //       </Button>
    //     );
    //   },
    // },
    // //   {
    // //     id: "visibility",
    // //     label: "Visibility",
    // //     align: "center",
    // //     renderCell: (row) => {
    // //       return (
    // //         <Typography sx={{ fontSize: "12px" }}>
    // //           {row.visibility.includes("Drivers") &&
    // //           row.visibility.includes("Clients")
    // //             ? row.visibility.includes("Drivers") &&
    // //               row.visibility.startsWith("Drivers")
    // //               ? "Drivers & Clients"
    // //               : "Clients & Drivers"
    // //             : row.visibility}
    // //         </Typography>
    // //       );
    // //     },
    // //   },
    // {
    //   id: "action",
    //   label: "Edit",
    //   align: "center",
    //   renderCell: (row) => {
    //     const isRowExpanded = expandedRows.includes(row._id);
    //     return (
    //       <IconButton
    //         sx={{
    //           fontSize: "8px",
    //           color: "rgba(104, 60, 140, 1)",
    //         }}
    //         onClick={() => navigate(`edit`, { state: row })}
    //         // Add your onClick logic for delete here
    //       >
    //         <img src={editimg} alt="" />
    //       </IconButton>
    //     );
    //   },
    // },
  ];
  // COLUMNS IN THE ORDER TABLE-----------------------------

  const handleExpandRow = (rowId) => {
    setExpandedRows((prev) =>
      prev.includes(rowId)
        ? prev.filter((id) => id !== rowId)
        : [...prev, rowId]
    );
  };

  // FUNCTION TO SET THE FILTERS IN filtrationData STATE -----------------------------
  const getFilteredData = (data) => {
    if (!data.visibility) data.visibility = "";
    if (!data.videoSourceType) data.videoSourceType = "";
    if (!data.search) data.search = "";
    setFiltrationData({
      ...filtrationData,
      ...data,
    });
    setPage(0);
  };
  // FUNCTION TO SET THE FILTERS IN filtrationData STATE -----------------------------
  return (
    <>
      <Grid container sx={{ padding: "0 18px" }}>
        <Grid item xs={12} md={6}>
          <Typography
            variant="h5"
            sx={{
              fontWeight: 700,
              fontSize: "30px",
              color: "#673C8E", // Return the value directly
            }}
          >
            Website Banner
          </Typography>
        </Grid>
      </Grid>
      <Box sx={{ paddingRight: "24px" }}>
        <DynamicTable
          rows={rows}
          type="website-banner"
          url="website-banner"
          setRows={setRows}
          searchPlaceholderData={searchInput}
          onSearchData={handleSearchInputChange}
          filterConfig={acceptedCategoryFilters} // Pass the filter checkbox options
          noRecordTitle="No website banner yet !" // no data title
          onFilterData={getFilteredData} // filteration data
          onResetFilters={() => {
            setFiltrationData((prev) => ({
              search: prev.search,
              from: "",
              to: "",
            }));
          }}
          filtrationData={filtrationData}
          paginationProps={{ limit, page, setLimit, setPage, total, setTotal }}
          columns={clientColumns} // Pass the columns prop
          expandedRows={expandedRows}
          handleExpandRow={handleExpandRow}
        />
        <Box
          sx={{
            padding: "0 18px",
            paddingRight: "24px",
            display: "flex",
            justifyContent: "end",
            alignItems: "center",
          }}
        >
          {inputDisabled ? (
            <IconButton
              sx={{
                fontSize: "8px",
                color: "rgba(104, 60, 140, 1)",
              }}
              onClick={() => setDisabled(false)}
              // Add your onClick logic for delete here
            >
              <img src={editimg} alt="" />
            </IconButton>
          ) : (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <Button
                onClick={() => {
                  setBannerInput(rows[0].message);
                  setDisabled(true);
                }}
                sx={{
                  borderColor: "#683C8C",
                  color: "#683C8C",
                  padding: "6px 40px",
                  fontSize: "15px",
                  fontWeight: 400,
                  textTransform: "capitalize",
                  "&:hover": {
                    borderColor: "#683C8C",
                    backgroundColor: "transparent",
                    color: "#683C8C",
                  },
                }}
                variant="outlined"
              >
                Cancel
              </Button>
              <Button
                onClick={handleUpdateBanner}
                sx={{
                  borderColor: "#683C8C",
                  color: "#ffffff",
                  padding: "6px 40px",
                  backgroundColor: "#683C8C",
                  fontSize: "15px",
                  fontWeight: 400,
                  textTransform: "capitalize",
                  "&:hover": {
                    borderColor: "#683C8C",
                    backgroundColor: "transparent",
                    color: "#683C8C",
                  },
                }}
                variant="outlined"
              >
                Update
              </Button>
            </Box>
          )}
        </Box>
      </Box>
    </>
  );
}
